import ImageGroup from "./ImageGroup"

const UMCAttrImageGroup = (props) => {
    return <span className={`attr-wrap attr-img-grp`}>
        <ImageGroup
            {...props}
            height={"2em"}
            width={"2em"}
            className={`${props.parentClassName}`}
        />
    </span>
}

export default UMCAttrImageGroup